
<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Vendor</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="vendorName"
             placeholder="Enter Vendor Name">
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text radius-0"><i class="fa fa-user fa-fw"></i></div>
        </div>
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="username" placeholder="Key Person Name">
      </div>
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text radius-0"><i class="fa fa-phone"></i></div>
        </div>
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="mobile" placeholder="Enter cell number">
      </div>
    </div>
    <div class="form-group">
      <div class="input-group mb-2">
        <div class="input-group-prepend">
          <div class="input-group-text radius-0"><i class="fa fa-envelope-o fa-fw"></i></div>
        </div>
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="email"
               placeholder="Key person email number">
      </div>
    </div>
    <div class="form-group">
      <textarea class="form-control radius-0 font-13" [(ngModel)]="address" placeholder="Key person address"></textarea>
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>
